import {
    FANCLUB_SET_DATA, FANCLUB_RESET_DATA,
} from './../constants/constants';

const initialState = {
    feedbackCompleted: false,
    currQuestion: {
        questionId: 'SAKPCLAIMSSSPOverall',
        questionText: 'How was your overall claims experience',
        questionAnswer: '',
        questionRating: '',
    },
    feedbackQuestions: [{
        questionId: 'SAKPCLAIMSSSPOverall',
        questionText: 'How was your overall claims experience',
        questionAnswer: '',
        questionRating: '',
    },
    {
        questionId: 'SAKPCLAIMSSSPRepairs',
        questionText: 'How would you rate your repairs',
        questionAnswer: '',
        questionRating: '',
    },
    {
        questionId: 'SAKPCLAIMSSSPCarHire',
        questionText: 'How would you rate your car hire experience',
        questionAnswer: '',
        questionRating: '',
    },
    {
        questionId: 'SAKPCLAIMSSSPConsultant',
        questionText: 'How do you rate your claims consultant',
        questionAnswer: '',
        questionRating: '',
    }
    ],
    currQuestionNumber: 0,
}

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case FANCLUB_SET_DATA:
            return {
                ...state,
                currQuestion: ('currQuestion' in action.payload) ? action.payload.currQuestion : state.currQuestion,
                feedbackQuestions: ('feedbackQuestions' in action.payload) ? action.payload.feedbackQuestions : state.feedbackQuestions,
                currQuestionNumber: ('currQuestionNumber' in action.payload) ? action.payload.currQuestionNumber : state.currQuestionNumber,
                feedbackCompleted: ('feedbackCompleted' in action.payload) ? action.payload.feedbackCompleted : state.feedbackCompleted,
            }
        case FANCLUB_RESET_DATA:
            return {
                feedbackCompleted: false,
                currQuestion: {
                    questionId: 'SAKPCLAIMSSSPOverall',
                    questionText: 'How was your overall claims experience',
                    questionAnswer: '',
                    questionRating: '',
                },
                currQuestionNumber: 0,
                feedbackQuestions: [{
                    questionId: 'SAKPCLAIMSSSPOverall',
                    questionText: 'How was your overall claims experience',
                    questionAnswer: '',
                    questionRating: '',
                },
                {
                    questionId: 'SAKPCLAIMSSSPRepairs',
                    questionText: 'How would you rate your repairs',
                    questionAnswer: '',
                    questionRating: '',
                },
                {
                    questionId: 'SAKPCLAIMSSSPCarHire',
                    questionText: 'How would you rate your car hire experience',
                    questionAnswer: '',
                    questionRating: '',
                },
                {
                    questionId: 'SAKPCLAIMSSSPConsultant',
                    questionText: 'How do you rate your claims consultant',
                    questionAnswer: '',
                    questionRating: '',
                }
                ]
            }
        default:
            return state
    }
}

export default modalReducer;